import { ChangeEvent, useCallback, useState } from 'react';

const useHandleAccordion = () => {
  const [expandedMemberId, setExpandedMemberId] = useState<string | false>(false);

  const handleChange = useCallback(
    (panel: string) => (_event: ChangeEvent<Record<string, unknown>>, isExpanded: boolean) => {
      setExpandedMemberId(isExpanded ? panel : false);
    },
    [],
  );

  return {
    expandedMemberId,
    handleChange,
  };
};

export default useHandleAccordion;
